import { LNGS_NAMESPACE_LOGICAL_DEVICE, LNGS_NAMESPACE_TASKS } from '@ingenico/util-i18n-config';
import { getDeviceCallLogsMapperOfStatus } from '@ingenico/react-ui/device-changes-call-logs-section';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

export function useInitialSetup() {
  const { t, ready: isTranslationReady } = useTranslation([
    ...Object.values(LNGS_NAMESPACE_TASKS),
    LNGS_NAMESPACE_LOGICAL_DEVICE.DEFAULT,
  ]);
  const datagridRef = useGridApiRef();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedTab = searchParams.get('selectedTab');
  const mapperOfStatus = useMemo(() => getDeviceCallLogsMapperOfStatus(), []);

  return { t, datagridRef, navigate, location, searchParams, selectedTab, mapperOfStatus, isTranslationReady };
}
